/* =========================================================
   QUEED PHONE MODEL DATABASE — 738 MODELS
   FULL REPLACEMENT FOR: queed-phone-models.js

   FEATURES
   - 738 phone models
   - Brand -> Model dropdown automatic binding
   - Model dropdown automatically enables
   - Works with Shopify Theme Editor section reload
   - Connects with QUEED_MODEL_ENGINE if available
========================================================= */

window.QUEED_PHONE_MODELS = {

  "Apple": [
    "iPhone 14",
    "iPhone 14 Plus",
    "iPhone 14 Pro",
    "iPhone 14 Pro Max",
    "iPhone SE (3rd generation)",
    "iPhone 15",
    "iPhone 15 Plus",
    "iPhone 15 Pro",
    "iPhone 15 Pro Max",
    "iPhone 16",
    "iPhone 16 Plus",
    "iPhone 16 Pro",
    "iPhone 16 Pro Max",
    "iPhone 16e",
    "iPhone 17",
    "iPhone 17 Pro",
    "iPhone 17 Pro Max",
    "iPhone Air",
    "iPhone 17e",
    "iPhone 18 Pro",
    "iPhone 18 Pro Max",
    "iPhone Duo"
  ],

  "Samsung": [
    "Galaxy A03",
    "Galaxy A04",
    "Galaxy A04e",
    "Galaxy A04s",
    "Galaxy A13 4G",
    "Galaxy A23 4G",
    "Galaxy A33 5G",
    "Galaxy A53 5G",
    "Galaxy A73 5G",
    "Galaxy F13",
    "Galaxy F23 5G",
    "Galaxy M04",
    "Galaxy M13",
    "Galaxy M13 5G",
    "Galaxy M33 5G",
    "Galaxy M53 5G",
    "Galaxy S21 FE 5G",
    "Galaxy S22",
    "Galaxy S22 Ultra",
    "Galaxy S22+",
    "Galaxy Z Flip4",
    "Galaxy Z Fold4",
    "Galaxy A05",
    "Galaxy A05s",
    "Galaxy A14 4G",
    "Galaxy A14 5G",
    "Galaxy A15 5G",
    "Galaxy A23 5G",
    "Galaxy A25 5G",
    "Galaxy A34 5G",
    "Galaxy A54 5G",
    "Galaxy F04",
    "Galaxy F14 5G",
    "Galaxy F34 5G",
    "Galaxy F54 5G",
    "Galaxy M14 5G",
    "Galaxy M34 5G",
    "Galaxy S23",
    "Galaxy S23 FE",
    "Galaxy S23 Ultra",
    "Galaxy S23+",
    "Galaxy Z Flip5",
    "Galaxy Z Fold5",
    "Galaxy A06",
    "Galaxy A16 5G",
    "Galaxy A35 5G",
    "Galaxy A55 5G",
    "Galaxy F05",
    "Galaxy F14 4G",
    "Galaxy F15 5G",
    "Galaxy F55 5G",
    "Galaxy M05",
    "Galaxy M14 4G",
    "Galaxy M15 5G",
    "Galaxy M35 5G",
    "Galaxy M55 5G",
    "Galaxy M55s 5G",
    "Galaxy S24",
    "Galaxy S24 FE",
    "Galaxy S24 Ultra",
    "Galaxy S24+",
    "Galaxy Z Flip6",
    "Galaxy Z Fold6",
    "Galaxy A06 5G",
    "Galaxy A07 4G",
    "Galaxy A17 5G",
    "Galaxy A26 5G",
    "Galaxy A36 5G",
    "Galaxy A56 5G",
    "Galaxy F06 5G",
    "Galaxy F16 5G",
    "Galaxy F36 5G",
    "Galaxy F56 5G",
    "Galaxy M06 5G",
    "Galaxy M16 5G",
    "Galaxy M17 5G",
    "Galaxy M36 5G",
    "Galaxy M56 5G",
    "Galaxy S25",
    "Galaxy S25 Edge",
    "Galaxy S25 FE",
    "Galaxy S25 Ultra",
    "Galaxy S25+",
    "Galaxy Z Flip7",
    "Galaxy Z Flip7 FE",
    "Galaxy Z Fold7",
    "Galaxy A07 5G",
    "Galaxy A27 5G",
    "Galaxy A37 5G",
    "Galaxy A57 5G",
    "Galaxy F70 Pro 5G",
    "Galaxy F70e 5G",
    "Galaxy M17e 5G",
    "Galaxy M47 5G",
    "Galaxy S26",
    "Galaxy S26 FE",
    "Galaxy S26 Ultra",
    "Galaxy S26+",
    "Galaxy Z Flip8",
    "Galaxy Z Fold8",
    "Galaxy Z Fold8 Ultra"
  ],

  "OnePlus": [
    "10 Pro 5G",
    "10R 5G",
    "10T 5G",
    "Nord 2T 5G",
    "Nord CE 2 5G",
    "Nord CE 2 Lite 5G",
    "11 5G",
    "11R 5G",
    "Nord 3 5G",
    "Nord CE 3 5G",
    "Nord CE 3 Lite 5G",
    "Open",
    "12",
    "12R",
    "Nord 4",
    "Nord CE 4",
    "Nord CE 4 Lite 5G",
    "13",
    "13R",
    "13s",
    "15",
    "15R",
    "Nord 5",
    "Nord CE 5 5G",
    "N6 5G",
    "N6x 5G",
    "Nord 6",
    "Nord CE 6 5G",
    "Nord CE 6 Lite 5G"
  ],

  "Oppo": [
    "A16e",
    "A16K",
    "A17",
    "A17k",
    "A57",
    "A76",
    "A77",
    "A77s",
    "A96",
    "F21 Pro",
    "F21 Pro 5G",
    "F21s Pro",
    "F21s Pro 5G",
    "K10",
    "K10 5G",
    "Reno7 5G",
    "Reno7 Pro 5G",
    "Reno8 5G",
    "Reno8 Pro 5G",
    "A18",
    "A38",
    "A58 4G",
    "A59 5G",
    "A78 4G",
    "A78 5G",
    "A79 5G",
    "F23 5G",
    "Find N2 Flip",
    "Reno10 5G",
    "Reno10 Pro 5G",
    "Reno10 Pro+ 5G",
    "Reno8 T 5G",
    "A3 5G",
    "A3 Pro 5G",
    "A3x 4G",
    "A3x 5G",
    "F25 Pro 5G",
    "F27 5G",
    "F27 Pro+ 5G",
    "Find X8",
    "Find X8 Pro",
    "K12x 5G",
    "Reno11 5G",
    "Reno11 Pro 5G",
    "Reno12 5G",
    "Reno12 Pro 5G",
    "A5 5G",
    "A5 Pro 5G",
    "A5x 5G",
    "A6x 5G",
    "F29 5G",
    "F29 Pro 5G",
    "F31 5G",
    "F31 Pro 5G",
    "F31 Pro+ 5G",
    "Find X9",
    "Find X9 Pro",
    "K13 5G",
    "K13 Turbo 5G",
    "K13 Turbo Pro",
    "K13x 5G",
    "Reno13 5G",
    "Reno13 Pro 5G",
    "Reno14 5G",
    "Reno14 Pro 5G",
    "A6 5G",
    "A6 Pro 5G",
    "F33 5G",
    "F33 Pro 5G",
    "Find X9 Ultra",
    "Find X9s",
    "K14 5G",
    "Reno15 5G",
    "Reno15 Pro 5G",
    "Reno15 Pro Mini",
    "Reno16 5G",
    "Reno16c 5G"
  ],

  "Vivo": [
    "T1 44W",
    "T1 5G",
    "T1 Pro 5G",
    "T1x",
    "V23 5G",
    "V23 Pro 5G",
    "V25",
    "V25 Pro",
    "X80",
    "X80 Pro",
    "Y01",
    "Y02",
    "Y15c",
    "Y16",
    "Y21G",
    "Y21T",
    "Y22",
    "Y33T",
    "Y35",
    "Y75",
    "Y75 5G",
    "T2 5G",
    "T2 Pro 5G",
    "T2x 5G",
    "V27",
    "V27 Pro",
    "V29",
    "V29 Pro",
    "X90",
    "X90 Pro",
    "Y100",
    "Y100A",
    "Y17s",
    "Y200 5G",
    "Y27",
    "Y36",
    "Y56 5G",
    "T3 5G",
    "T3 Lite 5G",
    "T3 Pro 5G",
    "T3 Ultra 5G",
    "T3x 5G",
    "V30",
    "V30 Pro",
    "V40",
    "V40 Pro",
    "V40e",
    "X100",
    "X100 Pro",
    "X200",
    "X200 Pro",
    "Y18",
    "Y18e",
    "Y200e 5G",
    "Y28 5G",
    "Y28e 5G",
    "Y28s 5G",
    "Y300 5G",
    "Y300 Plus 5G",
    "Y58 5G",
    "T4 5G",
    "T4 Lite 5G",
    "T4 Pro 5G",
    "T4 Ultra 5G",
    "T4R 5G",
    "T4x 5G",
    "V50",
    "V50e",
    "V60",
    "V60e",
    "X Fold5",
    "X200 FE",
    "X300",
    "X300 Pro",
    "Y19e",
    "Y29 5G",
    "Y39 5G",
    "Y400 5G",
    "Y400 Pro 5G",
    "S2 5G",
    "T5 5G",
    "T5 Lite 5G",
    "T5 Pro 5G",
    "T5e",
    "T5x",
    "V70",
    "V70 Elite",
    "V70 FE",
    "X200T",
    "X300 FE",
    "X300 Ultra",
    "Y11 5G",
    "Y31T 5G"
  ],

  "iQOO": [
    "iQOO 9",
    "iQOO 9 Pro",
    "iQOO 9 SE",
    "iQOO 9T",
    "iQOO Neo 6",
    "iQOO Z6 44W",
    "iQOO Z6 5G",
    "iQOO Z6 Lite 5G",
    "iQOO Z6 Pro 5G",
    "iQOO 11",
    "iQOO 12",
    "iQOO Neo 7",
    "iQOO Neo 7 Pro",
    "iQOO Z7 5G",
    "iQOO Z7 Pro 5G",
    "iQOO Z7s 5G",
    "iQOO 13",
    "iQOO Neo 9 Pro",
    "iQOO Z9 5G",
    "iQOO Z9 Lite 5G",
    "iQOO Z9s 5G",
    "iQOO Z9s Pro 5G",
    "iQOO Z9x 5G",
    "iQOO 15",
    "iQOO Neo 10",
    "iQOO Neo 10R",
    "iQOO Z10 5G",
    "iQOO Z10 Lite 5G",
    "iQOO Z10R",
    "iQOO Z10x 5G",
    "iQOO 15R",
    "iQOO Z11 5G",
    "iQOO Z11 Lite 5G",
    "iQOO Z11x",
    "iQOO Z11xa 5G"
  ],

  "Realme": [
    "realme 10",
    "realme 10 Pro 5G",
    "realme 10 Pro+ 5G",
    "realme 9 4G",
    "realme 9 5G",
    "realme 9 5G SE",
    "realme 9 Pro 5G",
    "realme 9 Pro+ 5G",
    "realme 9i",
    "realme 9i 5G",
    "realme C30",
    "realme C30s",
    "realme C31",
    "realme C33",
    "realme C35",
    "realme GT 2",
    "realme GT 2 Pro",
    "realme GT Neo 3",
    "realme GT Neo 3T",
    "realme Narzo 50",
    "realme Narzo 50 5G",
    "realme Narzo 50 Pro 5G",
    "realme Narzo 50A Prime",
    "realme Narzo 50i Prime",
    "realme 11 5G",
    "realme 11 Pro 5G",
    "realme 11 Pro+ 5G",
    "realme 11x 5G",
    "realme C51",
    "realme C53",
    "realme C55",
    "realme C67 5G",
    "realme Narzo 60 5G",
    "realme Narzo 60 Pro 5G",
    "realme Narzo 60x 5G",
    "realme Narzo N53",
    "realme Narzo N55",
    "realme 12 5G",
    "realme 12 Pro 5G",
    "realme 12 Pro+ 5G",
    "realme 12+ 5G",
    "realme 12x 5G",
    "realme 13 5G",
    "realme 13 Pro 5G",
    "realme 13 Pro+ 5G",
    "realme 13+ 5G",
    "realme C61",
    "realme C63",
    "realme C65 5G",
    "realme GT 6",
    "realme GT 6T",
    "realme GT 7 Pro",
    "realme Narzo 70 5G",
    "realme Narzo 70 Pro 5G",
    "realme Narzo 70 Turbo 5G",
    "realme Narzo 70x 5G",
    "realme Narzo N61",
    "realme P1 5G",
    "realme P1 Pro 5G",
    "realme P1 Speed 5G",
    "realme P2 Pro 5G",
    "realme 14 Pro 5G",
    "realme 14 Pro+ 5G",
    "realme 14T 5G",
    "realme 14x 5G",
    "realme 15 5G",
    "realme 15 Pro 5G",
    "realme 15T 5G",
    "realme 15x 5G",
    "realme C73 5G",
    "realme GT 7",
    "realme GT 7T",
    "realme GT 8 Pro",
    "realme Narzo 80 5G",
    "realme Narzo 80 Lite 5G",
    "realme Narzo 80 Pro 5G",
    "realme Narzo 80x 5G",
    "realme Narzo 90",
    "realme Narzo 90x",
    "realme P3 5G",
    "realme P3 Pro 5G",
    "realme P3 Ultra 5G",
    "realme P3x 5G",
    "realme P4 5G",
    "realme P4 Pro 5G",
    "realme P4x 5G",
    "realme 16 5G",
    "realme 16 Pro 5G",
    "realme 16 Pro+ 5G",
    "realme 16T 5G",
    "realme 16x 5G",
    "realme C83 5G",
    "realme P4 Power",
    "realme P4R 5G",
    "realme P4s 5G"
  ],

  "Xiaomi/Redmi": [
    "Redmi 10",
    "Redmi 10A",
    "Redmi 11 Prime",
    "Redmi 11 Prime 5G",
    "Redmi A1",
    "Redmi A1+",
    "Redmi K50i 5G",
    "Redmi Note 11",
    "Redmi Note 11 Pro",
    "Redmi Note 11 Pro+ 5G",
    "Redmi Note 11S",
    "Xiaomi 11i 5G",
    "Xiaomi 11i HyperCharge 5G",
    "Xiaomi 11T Pro 5G",
    "Xiaomi 12 Pro",
    "Redmi 12",
    "Redmi 12 5G",
    "Redmi 13C",
    "Redmi 13C 5G",
    "Redmi A2",
    "Redmi A2+",
    "Redmi Note 12 4G",
    "Redmi Note 12 5G",
    "Redmi Note 12 Pro 5G",
    "Redmi Note 12 Pro+ 5G",
    "Xiaomi 13 Pro",
    "Redmi 13 5G",
    "Redmi 14C",
    "Redmi A3",
    "Redmi A3x",
    "Redmi A4 5G",
    "Redmi Note 13 5G",
    "Redmi Note 13 Pro 5G",
    "Redmi Note 13 Pro+ 5G",
    "Redmi Note 14 5G",
    "Redmi Note 14 Pro 5G",
    "Redmi Note 14 Pro+ 5G",
    "Xiaomi 14",
    "Xiaomi 14 Civi",
    "Xiaomi 14 Ultra",
    "Redmi 15 5G",
    "Redmi 15C 5G",
    "Redmi A5",
    "Redmi Note 14 SE 5G",
    "Xiaomi 15",
    "Xiaomi 15 Ultra",
    "Redmi 17 5G",
    "Redmi Note 15 5G",
    "Redmi Note 15 Pro 5G",
    "Redmi Note 15 Pro+ 5G",
    "Redmi Note 15 SE 5G",
    "Redmi Note 17 5G",
    "Redmi Note 17 Pro 5G",
    "Redmi Note 17 Pro Max 5G",
    "Redmi Turbo 5",
    "Xiaomi 17",
    "Xiaomi 17 Ultra"
  ],

  "Poco": [
    "POCO C31",
    "POCO F4 5G",
    "POCO M4 5G",
    "POCO M4 Pro",
    "POCO M4 Pro 5G",
    "POCO M5",
    "POCO X4 Pro 5G",
    "POCO C50",
    "POCO C51",
    "POCO C55",
    "POCO C65",
    "POCO F5 5G",
    "POCO M6 5G",
    "POCO M6 Pro 5G",
    "POCO X5 5G",
    "POCO X5 Pro 5G",
    "POCO C61",
    "POCO C75",
    "POCO F6 5G",
    "POCO M6 Plus 5G",
    "POCO M7 Pro 5G",
    "POCO X6 5G",
    "POCO X6 Neo 5G",
    "POCO X6 Pro 5G",
    "POCO C71",
    "POCO F7 5G",
    "POCO M7 5G",
    "POCO M7 Plus 5G",
    "POCO X7 5G",
    "POCO X7 Pro 5G",
    "POCO F9 Ultra 5G",
    "POCO M8 Power 5G",
    "POCO M8x 5G",
    "POCO X8 5G",
    "POCO X8 Power 5G",
    "POCO X8 Pro",
    "POCO X8 Pro Max"
  ],

  "Google Pixel": [
    "Pixel 6a",
    "Pixel 7",
    "Pixel 7 Pro",
    "Pixel 7a",
    "Pixel 8",
    "Pixel 8 Pro",
    "Pixel 8a",
    "Pixel 9",
    "Pixel 9 Pro",
    "Pixel 9 Pro Fold",
    "Pixel 9 Pro XL",
    "Pixel 10",
    "Pixel 10 Pro",
    "Pixel 10 Pro Fold",
    "Pixel 10 Pro XL",
    "Pixel 9a",
    "Pixel 10a",
    "Pixel 11",
    "Pixel 11 Pro",
    "Pixel 11 Pro Fold",
    "Pixel 11 Pro XL"
  ],

  "Nothing": [
    "Phone (1)",
    "Phone (2)",
    "Phone (2a)",
    "Phone (2a) Plus",
    "Phone (3)",
    "Phone (3a)",
    "Phone (3a) Pro",
    "Phone (4a)",
    "Phone (4a) Pro",
    "Phone (4b)"
  ],

  "CMF": [
    "CMF Phone 1",
    "CMF Phone 2 Pro"
  ],

  "Motorola": [
    "Moto E22s",
    "Moto E32",
    "Moto E32s",
    "Moto G22",
    "Moto G32",
    "Moto G42",
    "Moto G52",
    "Moto G62 5G",
    "Moto G71 5G",
    "Moto G72",
    "Moto G82 5G",
    "Motorola Edge 30",
    "Motorola Edge 30 Fusion",
    "Motorola Edge 30 Pro",
    "Motorola Edge 30 Ultra",
    "Motorola Razr 2022",
    "Moto E13",
    "Moto G13",
    "Moto G14",
    "Moto G54 5G",
    "Moto G73 5G",
    "Moto G84 5G",
    "Motorola Edge 40",
    "Motorola Edge 40 Neo",
    "Motorola Razr 40",
    "Motorola Razr 40 Ultra",
    "Moto G04",
    "Moto G04s",
    "Moto G24 Power",
    "Moto G34 5G",
    "Moto G35 5G",
    "Moto G45 5G",
    "Moto G64 5G",
    "Moto G85 5G",
    "Motorola Edge 50",
    "Motorola Edge 50 Fusion",
    "Motorola Edge 50 Neo",
    "Motorola Edge 50 Pro",
    "Motorola Edge 50 Ultra",
    "Motorola Razr 50",
    "Motorola Razr 50 Ultra",
    "Moto G05",
    "Moto G57 Power 5G",
    "Moto G67 Power 5G",
    "Moto G86 Power 5G",
    "Moto G96 5G",
    "Motorola Edge 60",
    "Motorola Edge 60 Fusion",
    "Motorola Edge 60 Pro",
    "Motorola Edge 60 Stylus",
    "Motorola Edge 70",
    "Motorola Razr 60",
    "Motorola Razr 60 Ultra",
    "Moto g max 5G",
    "Moto G77 Power 5G",
    "Motorola Edge 70 Fusion",
    "Motorola Edge 70 Max",
    "Motorola Edge 70 Pro",
    "Motorola Razr 70 Ultra",
    "Motorola Razr Fold",
    "Motorola Signature"
  ],

  "Tecno": [
    "Tecno Camon 19",
    "Tecno Camon 19 Pro 5G",
    "Tecno Pova 3",
    "Tecno Pova Neo",
    "Tecno Spark 9",
    "Tecno Spark 9T",
    "Tecno Camon 20",
    "Tecno Camon 20 Premier 5G",
    "Tecno Camon 20 Pro 5G",
    "Tecno Phantom V Flip",
    "Tecno Phantom V Fold",
    "Tecno Pova 5",
    "Tecno Pova 5 Pro",
    "Tecno Spark 10",
    "Tecno Spark 10 5G",
    "Tecno Spark 10 Pro",
    "Tecno Spark Go 2023",
    "Tecno Camon 30 5G",
    "Tecno Camon 30 Premier 5G",
    "Tecno Camon 30S",
    "Tecno Phantom V Flip 2",
    "Tecno Phantom V Fold 2",
    "Tecno Pop 9 5G",
    "Tecno Pova 6 Neo",
    "Tecno Pova 6 Pro 5G",
    "Tecno Spark 20",
    "Tecno Spark 20 Pro 5G",
    "Tecno Spark Go 1",
    "Tecno Pova 7 5G",
    "Tecno Pova 7 Pro 5G",
    "Tecno Pova Curve 5G",
    "Tecno Pova Slim 5G",
    "Tecno Spark Go 2",
    "Tecno Spark Go 5G",
    "Tecno Camon 50 Ultra",
    "Tecno Pova 8 5G",
    "Tecno Pova 8 Pro 5G",
    "Tecno Pova Curve 2",
    "Tecno Spark 50 5G",
    "Tecno Spark Go 3 Pro 4G"
  ],

  "Infinix": [
    "Infinix Hot 12 Play",
    "Infinix Hot 12 Pro",
    "Infinix Hot 20 5G",
    "Infinix Hot 20 Play",
    "Infinix Note 12",
    "Infinix Note 12 5G",
    "Infinix Note 12 Pro 5G",
    "Infinix Note 12 Turbo",
    "Infinix Smart 6",
    "Infinix Zero 20",
    "Infinix Zero 5G",
    "Infinix Zero Ultra",
    "Infinix GT 10 Pro",
    "Infinix Hot 30 5G",
    "Infinix Hot 30i",
    "Infinix Note 30 5G",
    "Infinix Smart 7",
    "Infinix Smart 8",
    "Infinix Smart 8 HD",
    "Infinix Zero 30 5G",
    "Infinix GT 20 Pro",
    "Infinix Hot 50 5G",
    "Infinix Note 40 Pro 5G",
    "Infinix Note 40 Pro+ 5G",
    "Infinix Note 40X 5G",
    "Infinix Smart 8 Plus",
    "Infinix Smart 9 HD",
    "Infinix Zero 40 5G",
    "Infinix GT 30 Pro",
    "Infinix Hot 60 5G+",
    "Infinix Note 50s 5G",
    "Infinix Note 50X 5G",
    "Infinix Smart 10",
    "Infinix Hot 70 Pro 5G",
    "Infinix Note 60 Pro 5G"
  ],

  "HMD/Nokia": [
    "Nokia C21 Plus",
    "Nokia C31",
    "Nokia G11 Plus",
    "Nokia G21",
    "Nokia G60 5G",
    "Nokia C12",
    "Nokia C12 Pro",
    "Nokia C22",
    "Nokia C32",
    "Nokia G42 5G",
    "Nokia X30 5G",
    "HMD Crest 5G",
    "HMD Crest Max",
    "HMD Fusion",
    "HMD Vibe 5G",
    "HMD Vibe 2 5G"
  ],

  "ASUS/ROG": [
    "ROG Phone 5s Pro 5G",
    "ROG Phone 6",
    "ROG Phone 6 Pro",
    "ROG Phone 7",
    "ROG Phone 7 Ultimate",
    "ROG Phone 8 Pro",
    "ROG Phone 8 Pro Edition"
  ]

};


/* =========================================================
   Compatibility global
========================================================= */

var QUEED_PHONE_MODELS =
  window.QUEED_PHONE_MODELS;


/* =========================================================
   BRAND -> MODEL DROPDOWN BINDER
========================================================= */

(function(
  window,
  document
){

  "use strict";


  function bindPhoneSelector(){

    var root =
      document.getElementById(
        "queed-ai-lab"
      );


    if(!root){
      return false;
    }


    var brand =
      root.querySelector(
        "#q-brand"
      );


    var model =
      root.querySelector(
        "#q-model"
      );


    if(
      !brand ||
      !model
    ){
      return false;
    }


    /*
      Don't bind the same DOM twice.
    */

    if(
      root.getAttribute(
        "data-queed-phone-db-bound"
      ) === "1"
    ){

      /*
        Even if already bound,
        make sure disabled state
        is correct.
      */

      if(
        brand.value &&
        window.QUEED_PHONE_MODELS[
          brand.value
        ]
      ){

        model.disabled =
          false;

      }

      return true;
    }


    root.setAttribute(
      "data-queed-phone-db-bound",
      "1"
    );


    function populate(){

      var value =
        String(
          brand.value || ""
        ).trim();


      var db =
        window.QUEED_PHONE_MODELS ||
        {};


      model.innerHTML =
        '<option value="">Select model</option>';


      if(
        !value ||
        !Array.isArray(
          db[value]
        ) ||
        db[value].length === 0
      ){

        model.disabled =
          true;

        return;
      }


      db[value].forEach(
        function(name){

          var option =
            document.createElement(
              "option"
            );


          option.value =
            name;


          option.textContent =
            name;


          model.appendChild(
            option
          );

        }
      );


      /*
        CRITICAL:
        Enable model dropdown.
      */

      model.disabled =
        false;


      /*
        Reset selected model.
      */

      model.value =
        "";


      /*
        Tell geometry engine
        brand has changed.
      */

      if(
        window.QUEED_MODEL_ENGINE &&
        typeof window
          .QUEED_MODEL_ENGINE
          .applyAI === "function"
      ){

        setTimeout(
          function(){

            window
              .QUEED_MODEL_ENGINE
              .applyAI(
                root
              );

          },
          40
        );

      }

    }


    brand.addEventListener(
      "change",
      function(){

        populate();

      }
    );


    model.addEventListener(
      "change",
      function(){

        if(
          window.QUEED_MODEL_ENGINE &&
          typeof window
            .QUEED_MODEL_ENGINE
            .applyAI === "function"
        ){

          window
            .QUEED_MODEL_ENGINE
            .applyAI(
              root
            );

        }

      }
    );


    /*
      Theme editor sometimes loads
      with a previously selected brand.
    */

    if(
      brand.value
    ){

      populate();

    }

    else{

      model.disabled =
        true;

    }


    return true;

  }


  function start(){

    if(
      bindPhoneSelector()
    ){
      return;
    }


    /*
      AI Studio may appear after
      this asset executes.
    */

    var tries =
      0;


    var timer =
      setInterval(
        function(){

          tries +=
            1;


          if(
            bindPhoneSelector() ||
            tries >= 50
          ){

            clearInterval(
              timer
            );

          }

        },
        100
      );

  }


  if(
    document.readyState ===
    "loading"
  ){

    document.addEventListener(
      "DOMContentLoaded",
      start,
      {
        once:true
      }
    );

  }

  else{

    start();

  }


  /*
    Shopify theme editor
    section reload support.
  */

  document.addEventListener(
    "shopify:section:load",
    function(){

      setTimeout(
        function(){

          /*
            New section = new root,
            therefore binding can happen again.
          */

          bindPhoneSelector();

        },
        50
      );

    }
  );


})(window, document);